import { apiSlice } from "../apiSlice";

/**
 * Parametrica de orden de visualizacion por tipo documental (GEST0025, endpoint ordentipos).
 */
export const ordentipoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    //Todos los tipos del proceso en el orden de la consulta por DO (padres, hijos y otros)
    getListadoOrdenTipos: builder.query({
      query: ({ EMPNITXX, AREAIDXX }) => ({
        url: `ordentipos/listado`,
        params: { EMPNITXX, AREAIDXX },
      }),
      providesTags: ["reloadTable"],
    }),
    //Crea o actualiza el orden de una terna (si estaba inactivo lo reactiva)
    saveOrdenTipo: builder.mutation({
      query: (parameters) => ({
        url: `ordentipos`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["reloadTable"],
    }),
    //Crea o actualiza varias ternas en una transaccion: {ORDENESX: [{EMPNITXX, AREAIDXX, SERIEIDX, TIPOIDXX, ORDENXXX}]}
    saveOrdenTiposLote: builder.mutation({
      query: (parameters) => ({
        url: `ordentipos/lote`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["reloadTable"],
    }),
    inactivateOrdenTipo: builder.mutation({
      query: ({ EMPNITXX, AREAIDXX, SERIEIDX, TIPOIDXX }) => ({
        url: `ordentipos/${EMPNITXX}/${AREAIDXX}/${SERIEIDX}/${TIPOIDXX}`,
        method: "DELETE",
      }),
      invalidatesTags: ["reloadTable"],
    }),
  }),
});

export const { useGetListadoOrdenTiposQuery, useSaveOrdenTipoMutation, useSaveOrdenTiposLoteMutation, useInactivateOrdenTipoMutation } = ordentipoApiSlice;
